import React from "react";
import { useTranslation } from "react-i18next";
import { Link, useHistory } from "react-router-dom";
import {credentials} from '../../../auth/credentials';
import MenuSystem from "../../../layout/Menu-system";
import {SystemButton} from '../../../components/buttons/styles'
import { Container } from "./styles";
import iconAdSmall from "../../../assets/icon-adNoBorder.svg";
// import iconSubtitleSmall from "../../../assets/icon-cc-small.svg";
import iconLibrasSmall from "../../../assets/icon-handsSmall.svg";
import iconTranslationSmall from "../../../assets/icon-translation-small.svg";

import volumeIcon from '../../../assets/audioguia_small.svg'

const HostSetupResource = () => {

  const {t} = useTranslation();
  const history = useHistory();
  const key = localStorage.getItem("eventKey");
  if(key !== credentials.broadcastEvent10){
    history.push("/organizador/eventos-disponiveis")
  }
  return (
    <Container>
      <MenuSystem url="/organizador/eventos-disponiveis" />
      <div className="systemTransmission">
        <div className="systemInfo">
          <h3>{t("host-setup-resource-title")}</h3>
          <p>{t("host-setup-resource-subtitle")}</p>
          <div className="resources">

            <SystemButton className="resources__card">
              <Link
                to="/organizador/eventos/transmitir/event10/ad"
                id="audiodescription"
              >
                <img src={iconAdSmall} alt="Ícone de audiodescrição" />
                <p>{t("audiodescription-title")}</p>
              
              </Link> 
            </SystemButton>



            {/* <div className="resources__card">
              <a
                href="https://beplay-app.web.app/#/categories/1/events/4/room/1/idioma/1/accessibility/2/professional/5/video"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={iconSubtitleSmall} alt="Ícone de legendas" />
                <p className="baseline">{t("subtitle-title")}</p>
              </a>
            </div> */}

            {/* <SystemButton className="resources__card">
              <Link to="/organizador/eventos/transmitir/libras">
                <img src={iconLibrasSmall} alt="Ícone de libras" />
                <p>{t("libras-title")}</p>
              </Link>
            </SystemButton> */}


            {/* <SystemButton className="resources__card">
              <Link to="/organizador/eventos/transmitir/ingles-portugues">
                <img src={iconTranslationSmall} alt="Ícone de tradução" />
                <p>{t('trad-portugues')}</p>
              </Link>
            </SystemButton> */}

            {/* <SystemButton className="resources__card">
              <Link to="/organizador/eventos/transmitir/ingles">
                <img src={iconTranslationSmall} alt="Ícone de tradução" />
                <p>{t('trad-ingles')}</p>
              </Link>
            </SystemButton> */}

            {/* <SystemButton className="resources__card">
              <Link to="/organizador/eventos/transmitir/portugues">
                <img src={iconTranslationSmall} alt="Ícone de tradução" />
                <p>{t('trad-portugues')}</p>
              </Link>
            </SystemButton> */}

            {/* <SystemButton className="resources__card">
              <Link to="/organizador/eventos/transmitir/frances">
                <img src={iconTranslationSmall} alt="Ícone de tradução" />
                <p>{t('trad-frances')}</p>
              </Link>
            </SystemButton> */}

            {/* <SystemButton className="resources__card">
              <Link to="/organizador/eventos/transmitir/espanhol">
                <img src={iconTranslationSmall} alt="Ícone de tradução" />
                <p>{t('trad-espanhol')}</p>
              </Link>
            </SystemButton> */}


            {/* <SystemButton className="resources__card">
              <Link to="/organizador/eventos/transmitir/ad_audio_original">
                <img src={iconTranslationSmall} alt="Ícone de tradução" />
                <p>{t("audiodescription_original_audio_title")}</p>
              </Link>
            </SystemButton> */}

          </div>
        </div>
      </div>
    </Container>
  );
};
export default HostSetupResource;
